<article
  *ngIf="item"
  class="core-ui-attachment-card"
  [class.is-dragging]="dragging"
  [class.is-disabled]="disabled"
  [class.is-expanded]="expanded === true"
>
  <button
    type="button"
    class="core-ui-attachment-card__main"
    [disabled]="disabled"
    [attr.aria-expanded]="expanded"
    [attr.aria-label]="'Ver ' + item.name"
    (click)="select()"
  >
    <span
      class="core-ui-attachment-card__icon"
      [class.has-preview]="previewUrl"
    >
      <img
        *ngIf="previewUrl as imageUrl; else attachmentIcon"
        class="core-ui-attachment-card__preview"
        [src]="imageUrl"
        alt=""
        (error)="handlePreviewError()"
      >
      <ng-template #attachmentIcon>
        <core-ui-icon
          [name]="displayIcon"
          size="base"
          [color]="iconColor"
        ></core-ui-icon>
      </ng-template>
    </span>

    <span class="core-ui-attachment-card__content">
      <strong>{{ displayName }}</strong>
      <span class="core-ui-attachment-card__caption-row">
        <ng-container *ngIf="captionTemplate; else defaultCaption">
          <ng-container [ngTemplateOutlet]="captionTemplate"></ng-container>
        </ng-container>
        <ng-template #defaultCaption>
          <span class="core-ui-attachment-card__caption">{{ displayCaption }}</span>
          <span
            *ngIf="showCaptionArrow"
            class="core-ui-attachment-card__arrow"
            aria-hidden="true"
          >&rarr;</span>
        </ng-template>
      </span>
    </span>
  </button>

  <div *ngIf="actionContent" class="core-ui-attachment-card__actions">
    <ng-content select="[coreUiAttachmentCardAction]"></ng-content>
  </div>
  <div *ngIf="expanded" class="core-ui-attachment-card__detail">
    <ng-content select="[attachmentDetail]"></ng-content>
  </div>
</article>
